import React from "react";
import { Alert } from "antd";

const ErrorAlert = ({ error }) => {
  if (error === null) {
    return null;
  }

  return (
    <Alert type="error" message={<span style={{ color: "red" }}>{error}</span>} style={{ marginBottom: "12px" }} />
  );
};

export default ErrorAlert;
